const EOCColors = {
  Pink: "#e50071",
  Purple: "#101f53",
  White: "#fff",
  Black: "#000",
  Gray: "gray",
  LightGray: "#eee",
  Red: "red",
};

export default EOCColors;
